import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setDarkMode } from '@app/actions/whiteInkOptionsActions';

import ZoomTool from '@components/zoom-tool/ZoomTool';
import Toggle from '@components/toggle/Toggle';
import UndoRedoTool from './undo-redo-tool/UndoRedoTool';

import './TopToolPanel.scss';

const TopToolPanel = ({
  artworkPreview,
  artworkPreviewZoom,
  setDarkMode,
  isDarkMode,
  whiteInkOption,
  includesWhiteUnderprint,
  undoRedoProps,
}) => {
  const { minZoom = 0.05, maxZoom = 5 } = artworkPreview || {};
  const setZoomLevel = (zoom) => artworkPreview?.setZoomLevel(zoom);
  const autoZoom = () => artworkPreview?.setZoomLevel(artworkPreview.calculatePreferredZoom());
  const [darkModeDisabled, setDarkModeDisabled] = useState(true);

  useEffect(() => {
    const isRemoveWhiteOption = ['removeAllWhite', 'removeWhiteBackground', 'selectWhiteToRemove'].includes(whiteInkOption);

    setDarkModeDisabled(!includesWhiteUnderprint);
    setDarkMode(includesWhiteUnderprint && isRemoveWhiteOption);
  }, [includesWhiteUnderprint, whiteInkOption, setDarkMode]);

  const onDarkModeChange = () => {
    setDarkMode(!isDarkMode);
  }

  return (
    <div id="qau-white-options-top-tool-panel">
      <Toggle
        isToggled={isDarkMode}
        isDisabled={darkModeDisabled}
        onChange={onDarkModeChange}
        titleLocaleKey="qau-dark-mode-title"
        stateOnLocaleKey="qau-state-on-label"
        stateOffLocaleKey="qau-state-off-label"
      />
      <ZoomTool
        currentZoom={artworkPreviewZoom}
        minZoom={minZoom}
        maxZoom={maxZoom}
        setZoomLevel={setZoomLevel}
        autoZoom={autoZoom}
      />
      {whiteInkOption === 'selectWhiteToRemove' &&
        <UndoRedoTool {...undoRedoProps} />
      }
    </div>
  );
};

const mapStateToProps = ({
  whiteInkOptions: { artworkPreview, artworkPreviewZoom, isDarkMode, whiteInkOption, includesWhiteUnderprint } }) => ({
  artworkPreview,
  artworkPreviewZoom,
  isDarkMode,
  whiteInkOption,
  includesWhiteUnderprint,
});

const mapDispatchToProps = {
  setDarkMode,
};

TopToolPanel.propTypes = {
  artworkPreview: PropTypes.object,
  undoRedoProps: PropTypes.object.isRequired,
  artworkPreviewZoom: PropTypes.number.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(TopToolPanel);
